export enum OngoingABTests {
    OPEN_PRICES = "open-prices-test",
    SEMANTIC_SEARCH = "semantic-search"
}
export enum OngoingABTests {
    OPEN_PRICES = "open-prices-test",
    SEMANTIC_SEARCH = "semantic-search"
}
